export default __webpack_public_path__ + "static/media/squarespace.2fcf6096.png";